import React, { useCallback } from 'react';
import { IdcardOutlined, SolutionOutlined } from '@ant-design/icons';
import { Menu, Layout } from 'antd';
import { useHistory } from 'react-router-dom';
import './SideBar.scss';

const { Sider } = Layout;

export default function SideBar() {
  const history = useHistory();
  function navigateTo(path) {
    return () => history.push(`/${path}`);
  }

  return (
    <Layout className="SideBar">
      <Sider
        collapsible
        defaultCollapsed
        className="sider-in-out"
      >
        <div className="logo" />
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
          {
            [
              {
                icon: <IdcardOutlined />,
                label: 'Classes',
                handleNavClick: useCallback(navigateTo(''), [history])
              },
              {
                icon: <SolutionOutlined />,
                label: 'People',
                handleNavClick: useCallback(navigateTo('people'), [history])
              },
            ]
            .map(({ icon, label, handleNavClick }) => (
              <Menu.Item key={label} icon={icon} title={label} onClick={handleNavClick}>
                {label}
              </Menu.Item>
            ))
          }
        </Menu>
      </Sider>
    </Layout>
  );
}
